import * as React from 'react';

export interface DoubleRenderProps {
  value?: number | null;
}

export const DoubleRender = (props: DoubleRenderProps) => {
  return <React.Fragment>{props.value}</React.Fragment>;
};
